<template>
  <div class="personnel-form">
    <div class="wrapper">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <Title :title="`基本信息`"></Title>
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="ruleForm.mobile"></el-input>
          </el-form-item>
          <el-form-item label="头像：" prop>
            <UploadCover
              tips
              img_width="100"
              img_height="100"
              @uploadSuccess="uploadSuccess"
              :coverImg="ruleForm.head_img"
            ></UploadCover>
          </el-form-item>
          <el-form-item label="简介：" prop="desp">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8}"
              v-model="ruleForm.desp"
              placeholder="请输入员工简介"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态：" prop>
            <el-switch v-model="ruleForm.state"></el-switch>
          </el-form-item>
        </el-row>

        <el-row>
          <Title :title="`权限设置`"></Title>
          <el-form-item label="角色：" prop="role_id">
            <el-radio-group v-model="ruleForm.role_id" @change="getChoose" class="mt10">
              <el-row style="margin-bottom:20px;" v-for="(item,index) in roleList" :key="index">
                <el-radio :label="item.id">{{item.name}}</el-radio>
              </el-row>
            </el-radio-group>
          </el-form-item>
        </el-row>

        <el-row class="tc">
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import Title from "@/components/title";
//上传图片
import UploadCover from "@/components/single-upload.vue";

import { _roleIndex } from "@/api/role";

import { _adminAdd, _adminEdit } from "@/api/admin";

import qs from "qs";

export default {
  props: {
    formData: {
      type: Object,
      default: {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    formData(val) {
      this.formData.state == 1
      ? (this.formData.state = true)
        : (this.formData.state = false);
      for (const key in this.ruleForm) {
        this.ruleForm[key] = this.formData[key];
      }
    }
  },
  created() {
    this.initRoleList();
  },
  components: {
    Title,
    UploadCover
  },
  data() {
    return {
      ruleForm: {
        name: "",
        mobile: "",
        head_img: "",
        role_id: "",
        desp: "",
        state: true
      },
      //角色列表数据
      roleList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
        desp: [{ required: true, message: "请填写员工简介", trigger: "blur" }]
      }
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getChoose(val) {
      console.log(this.ruleForm.role_id);
    },
    //获取角色列表
    initRoleList() {
      _roleIndex({
        params: {}
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          this.roleList = res.result.list;
          console.log(this.roleList)
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //提交信息
    submit() {
      let data = { ...this.ruleForm };
      data.state == true ? (data.state = 1) : (data.state = 2);
      if (this.isEdit) {
        data.id = this.formData.id;
        this.sendQuest(_adminEdit, data);
      } else {
        this.sendQuest(_adminAdd, data);
      }
    },
    //编辑或者是添加的请求
    sendQuest(request, data) {
      request({
        data: qs.stringify(data)
      }).then(res => {
        if (res.resultCode == 1) {
          // 添加自己的信息
          this.$message.success(res.errorMsg);
          setTimeout(() => {
            this.$router.push({ path: "/system/personnel" });
          }, 1000);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    uploadSuccess(url) {
      this.ruleForm.head_img = url;
    }
  }
};
</script>

<style lang="less" scoped>
.personnel-form {
  padding: 20px;
  background: #ffffff;
  .wrapper {
    max-width: 1000px;
  }
}
</style>